// This file was seperated from note-controller.model.ts to fix an issue causing import errors on the admin
// site while building. This was due to note-controller.model.ts importing note-entry-toc component.

interface INoteControl {
	DIALOG: 'DIALOG',
	BAR: 'DIALOG',
	ENTER_NOTES: 'ENTER_NOTES',
	FULLSCREEN: 'FULLSCREEN'
}

const NoteControl: INoteControl = {
	'DIALOG': 'DIALOG',
	'BAR': 'DIALOG',
	'ENTER_NOTES': 'ENTER_NOTES',
	'FULLSCREEN': 'FULLSCREEN'
}

export interface NoteControlOptions {
	DIALOG: {
		maximized: boolean;
		style: Pick<CSSStyleDeclaration, 'width' | 'height' | 'minWidth' | 'minHeight'>;
		coordinates: Partial<Pick<CSSStyleDeclaration, 'left' | 'top'>>;
	},
	BAR: {
		maximized: boolean;
	},
	ENTER_NOTES: {}
}
export class NoteControlOptions {
	static validateOption(option?: any): NoteControlType | null {
		return (typeof option === 'string' && option in NoteControl) ? (option as NoteControlType) : null;
	}
}

export type NoteControlType = keyof INoteControl;